<template>
    <div
        class="tw-my-4"
    >
        <Heading title="Erzähle Deinem lokalen Reiseexperten von Deiner Traumreise." :size="3" />
        <textarea
            class="tw-w-full tw-p-2 tw-font-thin tw-resize-none tw-h-52 tw-overflow-x-hidden tw-rounded-sm"
            :class="[
                isActive ? 'tw-border-2 tw-border-black' : isHover ? 'tw-border tw-border-black' : 'tw-border tw-border-gray-300'
            ]"
            :placeholder="$t('messageBox.placeholder', { country: countryName })"
            @blur="handleBlur"
            @focus="isActive = true"
            @mouseover="isHover = true"
            @mouseleave="isHover = false"
            v-model="message"
        />
        <div
            class="tw-w-full tw-h-1 tw-bg-gray-300 tw-rounded-lg tw-mb-2"
        >
            <div
                class="tw-h-full tw-rounded-lg"
                :style="progressBar"
            />
        </div>
        <InfoSnippet
            v-if="motivator"
            :icon="motivator.icon"
            hasBackground
            hasNoYSpacing
            class="tw-mb-2"
            ref="motivator"
        >
            {{ motivator.text }}
        </InfoSnippet>
    </div>
</template>

<script>

import InfoSnippet from "./InfoSnippet.vue";

export default {
    name: "TravelMessageInput",
    components: {
        InfoSnippet,
    },
    props: {
        countryName: {
            type: String,
            required: true
        }
    },
    data: () => ({
        message: '',
        isActive: false,
        isHover: false,
        motivatorSteps: [
            {
                icon: 'PenIcon',
                text: 'Starte jetzt! Deine Traumreise beginnt mit ein paar Worten.',
                from: 0,
                to: 29,
                barColor: '#E15D61',
            },
            {
                icon: 'ThumbsUpIcon',
                text: 'Weiter so! Je mehr Informationen Du uns gibst, desto genauer können wir Dein erstes Angebot auf Dich anpassen!',
                from: 30,
                to: 99,
                barColor: '#FFAD00',
            },
            {
                icon: 'SuccessIcon',
                text: 'Sehr gut! Erzähl Deinem lokalen Reiseexperten, was Du noch erleben möchtest.',
                from: 100,
                to: 199,
                barColor: '#FFAD00',
            },
            {
                icon: 'RocketIcon',
                text: 'Genial! Deine Reiseplanung ist fast komplett.',
                from: 200,
                to: 299,
                barColor: '#FFAD00',
            },
            {
                icon: 'TrophyIcon',
                text: 'Perfekt! Dein Traumurlaub nimmt Form an.',
                from: 300,
                to: 99999999,
                barColor: '#02B504',
            },
        ],
    }),
    computed: {
        motivator() {
            return this.motivatorSteps.find((step) => {
                return this.message.length >= step.from && this.message.length <= step.to
            })
        },
        progressBar() {
            const progressPercentile = this.message ? this.message.length / 5 : 0
            return {
                "max-width": progressPercentile + "%",
                "background-color": this.motivator ? this.motivator.barColor : '#E15D61',
            }
        },
    },
    mounted() {
        if(this.$store.getters['tour/travelData'].message) {
            this.message = this.$store.getters['tour/travelData'].message;
        }
    },
    methods: {
        storeMessage() {
            this.$store.commit('tour/setMessage', this.message)
        },
        handleBlur() {
            this.isActive = false;
            this.storeMessage();
        },
    },
}
</script>

<style scoped>
textarea:focus,
textarea:focus-visible {
    -webkit-tap-highlight-color: transparent;
    -webkit-appearance: none;
    outline: none;
}

/* Ensure the container maintains its border styles when focused */
.tw-border-2 {
    border-width: 2px;
}
</style>
